module.exports = __webpack_public_path__ + "897e480a5943f2662978f255b617a2e8.pdf";